import { render, staticRenderFns } from "./_base-card-link.vue?vue&type=template&id=9abbc232&scoped=true"
import script from "./_base-card-link.vue?vue&type=script&lang=js"
export * from "./_base-card-link.vue?vue&type=script&lang=js"
import style0 from "./_base-card-link.vue?vue&type=style&index=0&id=9abbc232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abbc232",
  null
  
)

export default component.exports